import { Form } from 'components/organisms';
import { initialStatement } from 'components/organisms/forms/statements/ExchangeRatesForm';
import { useParamId } from 'hooks/useParamId';
import { useGetStatementDetail } from 'services/statements/index';

const Statement = () => {
  const i18nextPrefix = 'statements';
  const trackId = useParamId('statements');
  const { data, isLoading } = useGetStatementDetail(trackId);

  const datas = data
    ? {
        ...data,
        defaultTotalValue: parseFloat(data.defaultTotalValue.toFixed(2)),
      }
    : initialStatement;

  return (
    <Form.ExchangeRates
      i18nextPrefix={i18nextPrefix}
      initialValues={datas ?? initialStatement}
      onSubmit={() => {}}
      tittle={data?.salesChannelName}
      status={{ displayMode: true, isLoading }}
    />
  );
};

export default Statement;
